import { render, staticRenderFns } from "./LessonCopy.vue?vue&type=template&id=1396870b&"
import script from "./LessonCopy.vue?vue&type=script&lang=js&"
export * from "./LessonCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports